import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  sendRequest,
  changeQueryParams,
  selectQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

class TasksHeaderSort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: {
        types: [
          {
            param: '-created_at',
            title: t('По дате')
          },
          {
            param: '-cost_execution',
            title: t('По цене')
          },
          {
            param: '-rating',
            title: t('По рейтингу')
          }
        ]
      }
    };
  }

  changeSortParam = value => {
    let sortParam = value;
    if (value === this.props.selectQueryParams.sort) {
      const currOrderBy = value.includes('-')
        ? value.replace(/^-/, '')
        : `-${value}`;
      sortParam = currOrderBy;
    }
    this.changeQueryParams({
      sort: sortParam
    });
  };

  isActive = orderFieldName =>
    orderFieldName.replace(/^-/, '') ===
    this.props.selectQueryParams.sort.replace(/^-/, '');

  changeQueryParams = changeParams => {
    this.props.changeQueryParams({ ...changeParams, ...{ page: 1 } });
    this.props.sendRequest();
  };

  render() {
    const orderIcon = this.props.selectQueryParams.sort.includes('-') ? (
      <i className="fa fa-fw fa-sort-amount-desc" />
    ) : (
      <i className="fa fa-fw fa-sort-amount-asc" />
    );
    return (
      <div className="btn-toolbar" style={{ marginBottom: '12px' }}>
        <ul className="btn-toolbar-item nav nav-pills nav-pills_bordered pull-left">
          {this.state.sort.types.map(item => (
            <li
              key={`tasksTypeSortItem-${item.param}`}
              className={this.isActive(item.param) ? 'active' : ''}
            >
              <a
                href=""
                onClick={e => {
                  e.preventDefault();
                  this.changeSortParam(item.param);
                }}
              >
                {this.isActive(item.param) ? orderIcon : null}
                {item.title}
              </a>
            </li>
          ))}
        </ul>
        <div className="btn-toolbar-item visible-sm visible-xs">
          <a
            href=""
            className="btn btn-transparent"
            data-toggle="sidebar-r"
            onClick={e => e.preventDefault()}
          >
            Фильтр
          </a>
        </div>
      </div>
    );
  }
}

TasksHeaderSort.propTypes = {
  selectQueryParams: PropTypes.shape({
    sort: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  // eslint-disable-next-line
  listReduceName: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => ({
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});
const mapDispatchToProps = (dispatch, props) => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksHeaderSort)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksHeaderSort/TasksHeaderSort.js